<ng-container *transloco="let t">
  <div id="contact-card" class="card-base">
    <div id="contact-card-header" class="flex items-center gap-3 mb-4">
      <ld-svg-icon
        id="contact-card-icon"
        [src]="supportIcon"
        [attr.aria-label]="t('contactCardIconAlt')"
        class="w-8 h-8"
      />
      <h3 id="contact-card-title" class="text-card-title">
        {{ t('contactCardTitle') }}
      </h3>
    </div>

    <p id="contact-card-description" class="font-dm text-sm text-ld-neutral-700 leading-5 mb-4">
      {{ t('contactCardDescription') }}
    </p>

    <div id="contact-card-hours" class="font-dm text-sm text-ld-neutral-700 leading-5 mb-5">
      <p class="font-semibold">{{ t('contactCardHoursTitle') }}</p>
      <p>{{ t('contactCardWeekdayHours') }}</p>
      <p>{{ t('contactCardSaturdayHours') }}</p>
    </div>

    <div id="contact-card-links" class="flex flex-col gap-3">
      <a
        id="contact-link-chat"
        href="javascript:void(0)"
        (click)="openChat()"
        class="flex items-center gap-2 text-ld-primary font-dm text-sm font-medium cursor-pointer [&>span]:hover:underline"
      >
        <ld-svg-icon [src]="annotationIcon" class="w-4 h-4" />
        <span>{{ t('helpCardLetsChat') }}</span>
      </a>
      <a
        id="contact-link-message"
        href="javascript:void(0)"
        (click)="openMessageCenter()"
        class="flex items-center gap-2 text-ld-primary font-dm text-sm font-medium cursor-pointer [&>span]:hover:underline"
      >
        <ld-svg-icon [src]="contactMailIcon" class="w-4 h-4" />
        <span>{{ t('contactCardMessageLink') }}</span>
      </a>
      <a
        id="contact-link-phone"
        [href]="phoneTel()"
        class="flex items-center gap-2 text-ld-primary font-dm text-sm font-medium cursor-pointer [&>span]:hover:underline"
      >
        <ld-svg-icon [src]="contactPhoneIcon" class="w-4 h-4" />
        <span>{{ t('contactCardCallLink', { phone: phoneDisplay() }) }}</span>
      </a>
    </div>

    <div
      id="contact-card-share-screen"
      class="-mx-6 mt-4 flex flex-col gap-3 border-t border-ld-neutral-200 px-6 pt-4 md:-mx-8 md:px-8"
    >
      <p id="contact-card-share-screen-prompt" class="font-dm text-sm text-ld-neutral-700 leading-5">
        <span id="contact-card-share-screen-prompt-title" class="block font-semibold text-ld-neutral-900">
          {{ t('shareScreenCardStandardPromptTitle') }}
        </span>
        <span id="contact-card-share-screen-prompt-description" class="block">
          {{ t('shareScreenCardStandardPromptDescription') }}
        </span>
      </p>

      <button
        id="contact-card-share-screen-button"
        data-testid="contact-card-share-screen-button"
        type="button"
        class="inline-flex w-full items-center justify-center gap-2 rounded-[20px] bg-ld-lime px-5 py-2 font-dm text-base font-bold uppercase leading-6 tracking-[0.5px] text-ld-neutral-700 transition-colors cursor-pointer hover:bg-ld-lime-hover focus-visible:outline-2 focus-visible:outline-ld-primary focus-visible:outline-offset-2 disabled:cursor-not-allowed"
        [disabled]="isShareScreenLoading()"
        [class.opacity-60]="isShareScreenLoading()"
        [class.pointer-events-none]="isShareScreenLoading()"
        (click)="onShareScreenClick()"
      >
        @if (isShareScreenLoading()) {
          <mat-spinner id="contact-card-share-screen-spinner" diameter="16" class="inline-block" />
        } @else {
          <ld-svg-icon
            id="contact-card-share-screen-button-icon"
            [src]="screenshareIcon"
            aria-hidden="true"
            class="size-4 shrink-0 text-ld-neutral-700"
          />
        }
        <span id="contact-card-share-screen-button-label">{{ t('shareScreenCardButton') }}</span>
      </button>
    </div>
  </div>
</ng-container>
